import React, { useState } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import JobInformationPanel from './components/JobInformationPanel';
import ApplicationCard from './components/ApplicationCard';
import ApplicationFilters from './components/ApplicationFilters';
import MessagingPanel from './components/MessagingPanel';
import ApplicationStats from './components/ApplicationStats';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const JobDetailsAndApplications = () => {
  const [activeTab, setActiveTab] = useState('details');
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [showMessaging, setShowMessaging] = useState(false);

  const [filters, setFilters] = useState({
    skillMatch: 'all',
    availability: 'all',
    sortBy: 'date_desc',
    minRate: '',
    maxRate: '',
    affiliate: 'all',
    searchQuery: ''
  });

  const mockJob = {
    id: 'job-001',
    title: 'Warmtepomp Installatie Nieuwbouw Woning',
    description: `Wij zoeken een ervaren installateur voor de installatie van een moderne warmtepomp in een nieuwbouwwoning in Amsterdam Noord. Het project omvat:\n\n• Installatie van lucht-water warmtepomp (12 kW)\n• Aansluiting op vloerverwarming systeem\n• Integratie met bestaande CV-installatie\n• Programmering en inregeling van het systeem\n• Instructie aan bewoners over gebruik en onderhoud\n\nDe woning is volledig gereed voor installatie. Alle benodigde materialen worden geleverd. Wij verwachten een professionele uitvoering volgens de geldende normen en voorschriften.`,
    location: 'Amsterdam Noord, Nederland',
    workType: 'Warmtepomp Installatie',
    duration: '3-5 werkdagen',
    budget: 3500,
    status: 'open',
    postedDate: '2026-01-10T09:00:00',
    startDate: '2026-01-20T08:00:00',
    expectedEndDate: '2026-01-24T17:00:00',
    requiredSkills: ['Warmtepomp Installatie', 'CV Techniek', 'Vloerverwarming', 'Elektrische Aansluitingen', 'F-gassen Certificaat'],
    image: "https://images.unsplash.com/photo-1724489180534-3931f3787cb7",
    imageAlt: 'Modern white heat pump unit installed on exterior brick wall of residential building with connecting pipes and electrical conduit',
    coordinates: {
      lat: 52.3976,
      lng: 4.9152
    }
  };

  const mockApplications = [
  {
    id: 'app-001',
    contractorName: 'Pieter van den Berg',
    contractorSpecialization: 'Warmtepomp Specialist',
    contractorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_113acd116-1763292512957.png",
    contractorAvatarAlt: 'Professional headshot of middle-aged Dutch man with short gray hair wearing blue work uniform',
    rating: 4.9,
    reviewCount: 127,
    location: 'Amsterdam',
    completedJobs: 156,
    experience: '12 jaar ervaring',
    skillMatch: 95,
    proposedRate: 65,
    availability: 'Direct beschikbaar',
    appliedDate: '2026-01-11T10:30:00',
    skills: ['Warmtepomp Installatie', 'CV Techniek', 'Vloerverwarming', 'F-gassen Certificaat', 'Daikin Specialist'],
    coverMessage: 'Beste opdrachtgever,\n\nIk heb ruime ervaring met warmtepomp installaties in nieuwbouwwoningen. Ik ben gecertificeerd voor F-gassen en heb specifieke training gevolgd voor Daikin systemen. Ik kan direct starten en garandeer een professionele afwerking binnen de gestelde termijn.',
    portfolioSamples: [
    {
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10643b5d0-1764743120876.png",
      imageAlt: 'Completed heat pump installation showing outdoor unit mounted on concrete pad with neat piping arrangement'
    },
    {
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_152cf174c-1765174441920.png",
      imageAlt: 'Interior view of heat pump control panel and distribution system in modern utility room'
    },
    {
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e42156c6-1768427215396.png",
      imageAlt: 'Professional installation of underfloor heating manifold connected to heat pump system'
    }],

    referredBy: 'TechPartners BV',
    isVerified: true,
    status: 'pending'
  },
  {
    id: 'app-002',
    contractorName: 'Jan de Vries',
    contractorSpecialization: 'CV & Warmtepomp Technicus',
    contractorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef710a3b-1763300911137.png",
    contractorAvatarAlt: 'Professional photo of young Dutch technician with blonde hair in orange safety vest smiling at camera',
    rating: 4.7,
    reviewCount: 89,
    location: 'Zaandam',
    completedJobs: 98,
    experience: '8 jaar ervaring',
    skillMatch: 88,
    proposedRate: 58,
    availability: 'Vanaf 18 januari',
    appliedDate: '2026-01-11T14:15:00',
    skills: ['Warmtepomp Installatie', 'CV Techniek', 'Vloerverwarming', 'F-gassen Certificaat'],
    coverMessage: 'Goedemiddag,\n\nIk ben gespecialiseerd in warmtepomp installaties en heb recent een vergelijkbaar project afgerond in Amsterdam. Ik werk nauwkeurig en houd me aan alle veiligheidsvoorschriften. Graag bespreek ik de details met u.',
    portfolioSamples: [
    {
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1082a5ee6-1768585817999.png",
      imageAlt: 'Heat pump outdoor unit installation on residential property with professional cable management'
    },
    {
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13f38deff-1771330642850.png",
      imageAlt: 'Indoor heat pump control unit mounted on wall with digital display showing temperature settings'
    }],

    referredBy: 'InstallPro Network',
    isVerified: true,
    status: 'pending'
  },
  {
    id: 'app-003',
    contractorName: 'Marco Jansen',
    contractorSpecialization: 'Installatie Technicus',
    contractorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d3688c5d-1763295491839.png",
    contractorAvatarAlt: 'Headshot of experienced technician with dark hair and beard wearing gray work shirt',
    rating: 4.8,
    reviewCount: 143,
    location: 'Haarlem',
    completedJobs: 187,
    experience: '15 jaar ervaring',
    skillMatch: 82,
    proposedRate: 70,
    availability: 'Vanaf 22 januari',
    appliedDate: '2026-01-12T09:45:00',
    skills: ['CV Techniek', 'Warmtepomp Installatie', 'Elektrische Aansluitingen', 'F-gassen Certificaat'],
    coverMessage: 'Geachte opdrachtgever,\n\nMet 15 jaar ervaring in de installatiebranche kan ik u een kwalitatief hoogwaardige warmtepomp installatie garanderen. Ik werk volgens de laatste normen en voorschriften en zorg voor een nette afwerking.',
    portfolioSamples: null,
    referredBy: null,
    isVerified: true,
    status: 'pending'
  },
  {
    id: 'app-004',
    contractorName: 'Thomas Bakker',
    contractorSpecialization: 'Duurzame Energie Specialist',
    contractorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17b8ff88b-1763299133729.png",
    contractorAvatarAlt: 'Young professional technician with short brown hair wearing green company polo shirt',
    rating: 4.6,
    reviewCount: 67,
    location: 'Amsterdam',
    completedJobs: 72,
    experience: '6 jaar ervaring',
    skillMatch: 78,
    proposedRate: 55,
    availability: 'Direct beschikbaar',
    appliedDate: '2026-01-12T16:20:00',
    skills: ['Warmtepomp Installatie', 'Vloerverwarming', 'Zonnepanelen', 'F-gassen Certificaat'],
    coverMessage: 'Hallo,\n\nIk ben gespecialiseerd in duurzame energie installaties en heb veel ervaring met warmtepompen. Ik kan flexibel inspelen op uw planning en werk graag aan dit project mee.',
    portfolioSamples: [
    {
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b8bf28c-1769212738454.png",
      imageAlt: 'Modern heat pump system installation in residential garage with clean piping layout'
    }],

    referredBy: 'TechPartners BV',
    isVerified: false,
    status: 'pending'
  }];


  const mockMessages = [
  {
    id: 'msg-001',
    sender: 'contractor',
    text: 'Goedemiddag! Bedankt voor uw interesse in mijn aanmelding. Ik heb enkele vragen over het project.',
    timestamp: '2026-01-14T14:30:00',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_113acd116-1763292512957.png",
    avatarAlt: 'Professional headshot of middle-aged Dutch man with short gray hair wearing blue work uniform'
  },
  {
    id: 'msg-002',
    sender: 'you',
    text: 'Goedemiddag Pieter, natuurlijk! Stel gerust uw vragen.',
    timestamp: '2026-01-14T14:35:00',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ffde516e-1763293580273.png",
    avatarAlt: 'Professional business woman with brown hair in navy blazer smiling at camera'
  },
  {
    id: 'msg-003',
    sender: 'contractor',
    text: 'Is er al een locatie bepaald voor de buitenunit? En zijn er specifieke wensen voor de plaatsing?',
    timestamp: '2026-01-14T14:37:00',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_113acd116-1763292512957.png",
    avatarAlt: 'Professional headshot of middle-aged Dutch man with short gray hair wearing blue work uniform'
  },
  {
    id: 'msg-004',
    sender: 'you',
    text: 'Ja, de buitenunit komt aan de noordzijde van de woning. Er is een betonnen fundering aanwezig. Ik kan u foto\'s sturen als dat helpt.',
    timestamp: '2026-01-14T14:40:00',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ffde516e-1763293580273.png",
    avatarAlt: 'Professional business woman with brown hair in navy blazer smiling at camera'
  }];


  const applicationStats = {
    total: mockApplications?.length,
    pending: mockApplications?.filter((app) => app?.status === 'pending')?.length,
    accepted: mockApplications?.filter((app) => app?.status === 'accepted')?.length,
    avgMatch: Math.round(mockApplications?.reduce((sum, app) => sum + app?.skillMatch, 0) / mockApplications?.length)
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleResetFilters = () => {
    setFilters({
      skillMatch: 'all',
      availability: 'all',
      sortBy: 'date_desc',
      minRate: '',
      maxRate: '',
      affiliate: 'all',
      searchQuery: ''
    });
  };

  const handleViewProfile = (applicationId) => {
    console.log('View profile:', applicationId);
  };

  const handleSendMessage = (applicationId) => {
    const contractor = mockApplications?.find((app) => app?.id === applicationId);
    if (contractor) {
      setSelectedContractor({
        name: contractor?.contractorName,
        specialization: contractor?.contractorSpecialization,
        avatar: contractor?.contractorAvatar,
        avatarAlt: contractor?.contractorAvatarAlt
      });
      setShowMessaging(true);
    }
  };

  const handleAccept = (applicationId) => {
    console.log('Accept application:', applicationId);
  };

  const handleEditJob = () => {
    console.log('Edit job');
  };

  const handleCloseJob = () => {
    console.log('Close job');
  };

  const handleSendMessageInPanel = (messageText) => {
    console.log('Send message:', messageText);
  };

  const filteredApplications = mockApplications?.filter((app) => {
    if (filters?.skillMatch !== 'all') {
      if (filters?.skillMatch === 'high' && app?.skillMatch < 80) return false;
      if (filters?.skillMatch === 'medium' && (app?.skillMatch < 60 || app?.skillMatch >= 80)) return false;
      if (filters?.skillMatch === 'low' && app?.skillMatch >= 60) return false;
    }

    if (filters?.minRate && app?.proposedRate < parseInt(filters?.minRate)) return false;
    if (filters?.maxRate && app?.proposedRate > parseInt(filters?.maxRate)) return false;

    if (filters?.affiliate !== 'all') {
      if (filters?.affiliate === 'direct' && app?.referredBy) return false;
      if (filters?.affiliate !== 'direct' && app?.referredBy !== filters?.affiliate) return false;
    }

    if (filters?.searchQuery) {
      const query = filters?.searchQuery?.toLowerCase();
      const matchesName = app?.contractorName?.toLowerCase()?.includes(query);
      const matchesSkills = app?.skills?.some((skill) => skill?.toLowerCase()?.includes(query));
      if (!matchesName && !matchesSkills) return false;
    }

    return true;
  });

  return (
    <MainLayout userRole="client" userName="Maria Jansen">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
          Opdracht Details & Aanmeldingen
        </h1>
        <p className="text-sm md:text-base text-muted-foreground">
          Bekijk opdracht informatie en beheer installateur aanmeldingen
        </p>
      </div>
      <div className="lg:hidden mb-6">
        <div className="flex gap-2 border-b border-border">
          <button
            onClick={() => setActiveTab('details')}
            className={`flex-1 px-4 py-3 font-medium text-sm transition-smooth ${
            activeTab === 'details' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
            }>

            <Icon name="FileText" size={18} className="inline mr-2" />
            Details
          </button>
          <button
            onClick={() => setActiveTab('applications')}
            className={`flex-1 px-4 py-3 font-medium text-sm transition-smooth relative ${
            activeTab === 'applications' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
            }>

            <Icon name="Users" size={18} className="inline mr-2" />
            Aanmeldingen
            <span className="ml-2 px-2 py-0.5 bg-primary text-primary-foreground rounded-full text-xs">
              {mockApplications?.length}
            </span>
          </button>
        </div>
      </div>
      <div className="lg:grid lg:grid-cols-3 lg:gap-6">
        <div className={`lg:col-span-1 ${activeTab === 'details' ? 'block' : 'hidden lg:block'}`}>
          <JobInformationPanel
            job={mockJob}
            onEditJob={handleEditJob}
            onCloseJob={handleCloseJob} />

        </div>

        <div className={`lg:col-span-2 ${activeTab === 'applications' ? 'block' : 'hidden lg:block'}`}>
          <ApplicationStats stats={applicationStats} />

          <ApplicationFilters
            filters={filters}
            onFilterChange={handleFilterChange}
            onResetFilters={handleResetFilters}
            totalApplications={filteredApplications?.length} />


          {filteredApplications?.length === 0 ?
          <div className="bg-card rounded-lg border border-border p-8 md:p-12 text-center">
              <Icon name="Users" size={64} className="mx-auto mb-4 text-muted-foreground" />
              <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
                Geen aanmeldingen gevonden
              </h3>
              <p className="text-sm md:text-base text-muted-foreground mb-4">
                Pas uw filters aan om meer resultaten te zien
              </p>
              <Button variant="outline" onClick={handleResetFilters}>
                Reset Filters
              </Button>
            </div> :

          <div className="space-y-4">
              {filteredApplications?.map((application) =>
            <ApplicationCard
              key={application?.id}
              application={application}
              onViewProfile={handleViewProfile}
              onSendMessage={handleSendMessage}
              onAccept={handleAccept} />

            )}
            </div>
          }
        </div>
      </div>
      {showMessaging && selectedContractor &&
      <MessagingPanel
        contractor={selectedContractor}
        messages={mockMessages}
        onSendMessage={handleSendMessageInPanel}
        onClose={() => setShowMessaging(false)} />

      }
    </MainLayout>);

};

export default JobDetailsAndApplications;